import { render, staticRenderFns } from "./viewBatchReportComponent.vue?vue&type=template&id=e345f61a&"
import script from "./viewBatchReportComponent.vue?vue&type=script&lang=js&"
export * from "./viewBatchReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports